// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WjjF","col":"styles_col__TdRcY"};